import React, { useState } from "react";
import { Button, Grid, TextField, Link, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useFormik } from "formik";
import * as yup from "yup";
import PasswordComponent, { passwordValidation } from "../components/PasswordComponent";
import AppBackService from "../services/appback";
import s from "./SignUp.module.scss";

const validationSchema = yup.object({
  first_name: yup.string("Enter your first name").required("First name is required"),
  last_name: yup.string("Enter your last name").required("Last name is required"),
  email_address: yup
    .string("Enter your email address")
    .email("Please enter valid email")
    .required("Email address is required"),
  password: passwordValidation(),
});

const SignUp = () => {
  const [values, setValues] = React.useState({
    othercountry: false,
    first_name: "",
    last_name: "",
    email_address: "",
    password: "",
    confirm_password: "",
    phone_number: "",
    showPassword: false,
    showConfirmPassword: false,
    showConfirmation: false,
    authCode: "",
    userSub: "",
    error: "",
    error1: "",
    auth_code_error: "",
    first_name_required_error: "",
    last_name_required_error: "",
    email_required_error: "",
    email_valid_error: "",
    password_required_error: "",
    confirm_password_required_error: "",
  });
  const [zAuthCode, setzAuthCode] = useState(new URLSearchParams(window.location.search).get("code"));

  let location = useLocation();
  let loginUrlWithQueryParams = "/login" + location.search;

  const handleSubmit = (model) => {
    setValues({ ...values });
    const { email_address, password } = model;
    const username = email_address.toLowerCase();
    try {
      Auth.signUp({
        username,
        password,
        attributes: {
          email: email_address.toLowerCase(),
          given_name: model.first_name,
          family_name: model.last_name,
        },
      })
        .then((data) => {
          setValues({
            showConfirmation: true,
            email_address: username,
            password,
            first_name: values.first_name,
            last_name: values.last_name,
            userSub: data.userSub,
          });
          console.log("calling addZoomAuthCode with userSub: " + data.userSub + " and zAuthCode: " + zAuthCode);
          AppBackService.upsertZoomAuthCode(data.userSub, zAuthCode);
        })
        .catch((error) => {
          if (error.message === "An account with the given email already exists.") {
            setValues({ ...values, error: error.message });
          } else setValues({ ...values, error: error.message });
        });
    } catch (error) {
      setValues({ ...values, error: error.message });
    }
  };

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email_address: "",
      phone_number: "",
      password: "",
    },
    validationSchema,
    onSubmit: (model) => {
      handleSubmit(model);
    },
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChangePassword = (prop) => (event) => {
    formik.values.password = event.target.value;
    setValues({
      ...values,
      [prop]: event.target.value,
    });
  };

  return (
    <div>
      {!values.showConfirmation && (
        <div>
          <p className={s.signupLoginHeader}>Create Account</p>
          <p className={s.errorText}>{values.error}</p>
          <div className={s.formDiv}>
            <form onSubmit={formik.handleSubmit} className={s.form}>
              <Grid container spacing={1} columns={2} rowSpacing="0px" className={s.nameGrid}>
                <Grid item xs={1} sm={1} md={1} lg={1}>
                  <Typography className={s.nameFieldLabel} align="left">
                    First Name
                  </Typography>
                  <TextField
                    variant="outlined"
                    className={s.nameTextField}
                    size="medium"
                    id="first_name"
                    name="first_name"
                    placeholder="First Name"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                    helperText={formik.touched.first_name && formik.errors.first_name}
                  />
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1}>
                  <Typography className={s.nameFieldLabel} align="left">
                    Last Name
                  </Typography>
                  <TextField
                    variant="outlined"
                    className={s.nameTextField}
                    size="medium"
                    id="last_name"
                    name="last_name"
                    placeholder="Last Name"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                    helperText={formik.touched.last_name && formik.errors.last_name}
                  />
                </Grid>
              </Grid>
              <Typography className={s.infoFieldLabel} align="left">
                Email Address
              </Typography>
              <TextField
                variant="outlined"
                className={s.infoTextField}
                id="email_address"
                name="email_address"
                placeholder="Email Address"
                value={formik.values.email_address}
                onChange={formik.handleChange}
                error={formik.touched.email_address && Boolean(formik.errors.email_address)}
                helperText={formik.touched.email_address && formik.errors.email_address}
              />
              <Typography className={s.infoFieldLabel} align="left">
                Password
              </Typography>
              <PasswordComponent
                values={values}
                placeholder="Password"
                name="password"
                type={values.showPassword ? "text" : "password"}
                value={formik.values.password}
                onChange={handleChangePassword("password")}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                style={{ width: "88%", marginBottom: "20px", backgroundColor: "var(--color-bg-form)" }}
                label=""
              />
              <p>
                By signing up, you agree to the&nbsp;
                <Link className={s.link} href="https://vtapestry.com/tos">
                  Terms and Conditions
                </Link>
                &nbsp;and&nbsp;
                <Link className={s.link} href="https://vtapestry.com/privacy">
                  Privacy Policy
                </Link>
                .
              </p>
              <Button type="submit" variant="contained" className={s.button} id="continue_button">
                CONTINUE
              </Button>
              <br />
            </form>
          </div>
          <Grid container spacing={1} justifyContent="center" className={s.gridContainer}>
            <div className={s.belowSignup}>
              <Grid container spacing={0}>
                <p>
                  Already have an account? &nbsp;
                  <Link className={s.link} href={loginUrlWithQueryParams}>
                    Login
                  </Link>
                </p>
              </Grid>
            </div>
          </Grid>
        </div>
      )}
      {values.showConfirmation && (
        <div>
          <p
            align="center"
            style={{
              paddingLeft: "30px",
              paddingRight: "30px",
              paddingBottom: "24px",
            }}>
            We have sent an email verification link to you at {values.email_address}
            .
            <br />
            <br />
            Please close this tab and click on the link in your email to verify the email address.
          </p>
        </div>
      )}
    </div>
  );
};

export default SignUp;
